import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DpzLogo from "../SVGComponents/DpzLogo";
import DomLogo from "../SVGComponents/DomLogo";
import OrderWithDom from "../SVGComponents/OrderWithDom";
import OrderWithDomHandheld from "../SVGComponents/OrderWithDomHandheld";
import { isHandheld } from "../App/utils";
import "./css/header.css";

const Header = ({ customerObj, loggedIn, showOverlay }) => {
  const [isInHandheldView, updateIsHandheld] = useState(isHandheld());

  useEffect(() => {
    const updateDimensions = () => {
      updateIsHandheld(isHandheld());
    };

    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  });

  return (
    <div className="chat__header">
      <div className="logo">
        <button
          data-quid="return-to-dom"
          type="button"
          onClick={() => showOverlay("return")}
        >
          <DpzLogo />
          <p>dominos.com</p>
        </button>
      </div>
      <div className="dom__logo">
        <div className="dom__logo__lockup">
          <DomLogo />
          {isInHandheldView ? <OrderWithDomHandheld /> : <OrderWithDom />}
        </div>
      </div>
      {loggedIn && (
        <h1 data-quid="user-greeting" className="user-greeting">
          Hi, {customerObj.FirstName}!
        </h1>
      )}
    </div>
  );
};

Header.propTypes = {
  loggedIn: PropTypes.bool,
  customerObj: PropTypes.shape({
    FirstName: PropTypes.string
  }),
  showOverlay: PropTypes.func.isRequired
};

Header.defaultProps = {
  loggedIn: false,
  customerObj: {
    FirstName: "Maverick"
  }
};

export default Header;
